/// <amd-module name="Mention/IdentityAutocomplete/IdentityAutocompleteCommand" />
import * as Resources from "Mention/IdentityAutocomplete/Resources";
import { IMarkdownToolbarCommand } from "VSS/Features/MarkdownEditor/Commands/Toolbar";
import { insertText } from "VSS/Features/MarkdownEditor/Formatting/Common";
import { IMarkdownFormattingArgs, IMarkdownFormattingResult } from "VSS/Features/MarkdownEditor/Formatting/Contracts";
import { IIconProps } from "VSSUI/Icon";

export class IdentityAutocompleteCommand implements IMarkdownToolbarCommand {
    private identityCharacter = "@";
    public id = "identity-autocomplete";
    public iconProps: IIconProps = { iconName: "Accounts" };
    public text = Resources.IdentityToolbarCommandText;
    public rank = 90;

    public formatText = (formattingArgs: IMarkdownFormattingArgs, errorHandler: (error: Error) => void): IMarkdownFormattingResult => {
        return insertText(formattingArgs, this.identityCharacter);
    };
}
